import React from 'react';
import { useTranslation } from 'react-i18next';

import { StepStart, StepStartProps } from './StepStart';
import { StepAuth, StepAuthProps } from './StepAuth';

import { useLogin } from './useLogin';
import { Steps } from './useLogin';

type LoginViewProps = StepStartProps & StepAuthProps;

const loginView: Record<Steps, React.FC<LoginViewProps>> = {
  [Steps.start]: StepStart,
  [Steps.auth]: StepAuth,
};

export const Login: React.FC<{ shopDomain: string }> = ({ shopDomain }) => {
  const { t } = useTranslation();
  const { step, ...props } = useLogin({ shopDomain });

  const View = loginView[step];

  return (
    <div className="bundleapp-login-block">
      <View {...props} t={t} />
    </div>
  );
};
